const getTitleAndMessage = (product, itemStatus, displayEddOrderDetailsPage) => {
    const dateToArrive = (product.shippingExpectation && product.shippingExpectation.ETA) || null
    let hasETA = false
    let title = itemStatus
    let showTrack = false
    let showReturn = false
    let messaging = ''
    let deliveryDate = (product?.actualDeliveryDate != "0000-00-00 00:00:00" && product?.actualDeliveryDate) || (product?.parentSku?.actual_delivery_date != "0000-00-00 00:00:00" && product?.parentSku?.actual_delivery_date);

    const dateFormat = new Intl.DateTimeFormat('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC',
    })

    switch (itemStatus) {
        case 'Pending':
        case 'Processing':
            showReturn = false;
            showTrack = false;
            break;
        case 'Shipped':
        case 'Order Shipped':
            if (deliveryDate && deliveryDate !== "0000-00-00 00:00:00") {
           
                title = 'Delivered';
                if (product.trackingUrl) {
                    showTrack = true
                }
                showReturn = true
            }
            else {
                showReturn = false;
                hasETA = true

                if (product.trackingUrl) {
                    showTrack = true
                }
            }
            break
        default:
            messaging = ''
    }

    if (product.return_request_status || product.credit_status || product.returnRequest) {
        showReturn = false
    }

    if (displayEddOrderDetailsPage === 'true' && hasETA && dateToArrive) {
        const parsedDate = new Date(dateToArrive)
        const shippingCompany = product.shippingCompany
            ? ` via ${product.shippingCompany}`
            : ''
        messaging = `Arriving on ${dateFormat.format(parsedDate)} ${shippingCompany}`
    }

    return {
        title,
        messaging,
        showTrack,
        showReturn,
    }
}

export default getTitleAndMessage
